import * as readline from 'node:readline';
import { isInteractive } from './env.js';

/**
 * Yes/no confirmation. When stdin/stdout aren't a TTY (pipes, CI) it resolves to `true`
 * immediately so non-interactive callers keep their existing non-blocking behavior — guard
 * destructive paths with an explicit `--yes` flag, not this prompt, for scripts.
 */
export function confirm(question: string, opts: { defaultYes?: boolean } = {}): Promise<boolean> {
  if (!isInteractive()) return Promise.resolve(true);

  const suffix = opts.defaultYes ? '[Y/n]' : '[y/N]';
  const rl = readline.createInterface({ input: process.stdin, output: process.stdout });
  return new Promise((resolve) => {
    rl.question(`${question} ${suffix}: `, (answer) => {
      rl.close();
      const a = answer.trim().toLowerCase();
      if (a === '') return resolve(Boolean(opts.defaultYes));
      resolve(a === 'y' || a === 'yes');
    });
  });
}

/**
 * Read one line of free-form input (trimmed). Callers must gate on `isInteractive()` first —
 * unlike `confirm()`, there's no sensible non-TTY default for an open-ended answer.
 */
export function promptLine(question: string): Promise<string> {
  const rl = readline.createInterface({ input: process.stdin, output: process.stdout });
  return new Promise((resolve) => {
    rl.question(question, (answer) => {
      rl.close();
      resolve(answer.trim());
    });
  });
}
